import { useEffect, useState } from 'react';

import { JWT } from 'domains/jwtToken/types';

import { IProjectSubchains } from './useProjectSubchains';

export interface UseIsAllIndeterminateProps {
  allCurrentChainPaths: string[];
  isAllSelected: boolean;
  isLoadingAddChainsToProjects: boolean;
  projects: JWT[];
  selectedSubchains: IProjectSubchains;
}

interface CheckIsAllIndeterminateParams
  extends Omit<UseIsAllIndeterminateProps, 'isLoadingAddChainsToProjects'> {}

const checkIsAllIndeterminate = ({
  allCurrentChainPaths,
  isAllSelected,
  projects,
  selectedSubchains,
}: CheckIsAllIndeterminateParams) =>
  projects.some(({ userEndpointToken }) =>
    allCurrentChainPaths.some(path =>
      selectedSubchains[userEndpointToken]?.includes(path),
    ),
  ) && !isAllSelected;

export const useIsAllIndeterminate = ({
  allCurrentChainPaths,
  isAllSelected,
  isLoadingAddChainsToProjects,
  projects,
  selectedSubchains,
}: UseIsAllIndeterminateProps) => {
  const [isAllIndeterminate, setIsAllIndeterminate] = useState(
    checkIsAllIndeterminate({
      allCurrentChainPaths,
      isAllSelected,
      projects,
      selectedSubchains,
    }),
  );

  useEffect(() => {
    if (!isLoadingAddChainsToProjects) {
      setIsAllIndeterminate(
        checkIsAllIndeterminate({
          allCurrentChainPaths,
          isAllSelected,
          projects,
          selectedSubchains,
        }),
      );
    }
  }, [
    isLoadingAddChainsToProjects,
    allCurrentChainPaths,
    isAllSelected,
    projects,
    selectedSubchains,
  ]);

  return isAllIndeterminate;
};
